<template>
  <span @click.capture.stop.prevent="opened=true">
    <slot></slot>
  </span>
  <BaseDialog
    v-model="opened"
    close
    content-width="400px"
  >
    <BaseCard class="m_pa16 m_bg-white m_flex m_flex-column m_flex-grow1 m_hov-elevation-1 m_hov-border-none">
      В связи с временными ограничениями в работе WhatsApp, просим направлять ваши обращения через
      <a
        :href="link"
        target="_blank"
        rel="noopener noreferrer"
      >
        Telegram
      </a>
      или в нашу <a :href="isMTI ? 'mailto:help@moicapital.ru' : 'mailto:help@synergyfriends.ru'">техническую поддержку</a>
    </BaseCard>
  </BaseDialog>
</template>

<script setup lang="ts">
import {
  projectName,
  projectNames,
} from '@/shared/constants/system';
import BaseCard from '@/shared/lib/uikit/components/BaseCard/BaseCard.vue';
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import {
  computed,
  ref,
} from 'vue';

const opened = ref(false);

const link = computed(() => (projectName === projectNames.MTI ? 'https://t.me/mti_mc' : 'https://t.me/mteam_supp'));
</script>
